function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 18.956h3v-18h-3v18zM18.5 3.956v-3H8v3h10.5zM21.5 8.456v3H8v-3h13.5zM18.5 18.956v-3H8v3h10.5z"
});

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "#81858D"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMiAxOSIgZmlsbD0iIzgxODU4RCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxOC45NTYxSDMuNUwzLjUgMC45NTYwNTVIMC41VjE4Ljk1NjFaIiBmaWxsPSIjODE4NThEIi8+CjxwYXRoIGQ9Ik0xOC41IDMuOTU2MDZWMC45NTYwNTVIOFYzLjk1NjA2TDE4LjUgMy45NTYwNloiIGZpbGw9IiM4MTg1OEQiLz4KPHBhdGggZD0iTTIxLjUgOC40NTYwNlYxMS40NTYxTDggMTEuNDU2MVY4LjQ1NjA1TDIxLjUgOC40NTYwNloiIGZpbGw9IiM4MTg1OEQiLz4KPHBhdGggZD0iTTE4LjUgMTguOTU2MVYxNS45NTYxSDhWMTguOTU2MUgxOC41WiIgZmlsbD0iIzgxODU4RCIvPgo8L3N2Zz4=";
export { SvgList as ReactComponent };